// extracted by mini-css-extract-plugin
module.exports =  {"modal__buttonContainer":"plpc__UMQjXst8ZzYkqIkBgo6Z","modal__text":"plpc__e80mJvZDZhtLbChrN9ri"};